import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    data: Array,
    labels: Array,
  };

  connect() {
    let options = {
      series: this.dataValue,
      chart: {
        type: "area",
        toolbar: {
          show: false,
        },
        height: 350,
      },
      colors: ["#008FFB", "#CED4DC", "#00E396", "#ed444c"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "monotoneCubic",
        width: 2,
      },
      fill: {
        type: "gradient",
        gradient: {
          opacityFrom: 0.5,
          opacityTo: 0.8,
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        show: false,
        showAlways: false,
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },

        categories: this.labelsValue,
      },
      yaxis: {
        show: false,
        showAlways: false,
        labels: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
    };

    this.chart = new ApexCharts(this.element, options);
    this.chart.render();
  }
}
